import axios from 'axios'
import type { UserRole } from '@/types'

/** Admin/Manager may view any task; Operator only tasks assigned to themselves. */
export function canViewTask(
  task: { assigned_to: string | null },
  viewer: { id?: string | null; role?: UserRole | null } | null | undefined
): boolean {
  if (!viewer?.id) return false
  if (viewer.role === 'Admin' || viewer.role === 'Manager') return true
  return task.assigned_to !== null && task.assigned_to === viewer.id
}

/** Admin may update any task status; others only tasks assigned to themselves. */
export function canUpdateTaskStatus(
  task: { assigned_to: string | null },
  viewer: { id?: string | null; role?: UserRole | null } | null | undefined
): boolean {
  if (!viewer?.id) return false
  if (viewer.role === 'Admin') return true
  return task.assigned_to !== null && task.assigned_to === viewer.id
}

/** True when a react-query / axios failure is HTTP 403. */
export function isForbiddenError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 403
}
